<template>
  <router-view v-if="layoutLoaded" />
</template>
<script>
import { EafTenantApi } from '@wiz-api/eaf-tenant-management'
import { EafProfileApi } from '@wiz-api/account'
import axios from 'axios'
import { forIn, cloneDeep } from 'lodash'

export default {
  name: 'layout-fullscreen',
  data() {
    return {
      eafTenantApi: null,
      eafProfileApi: null,
      layoutLoaded: false,
      token: '',
      tenant: {
        id: '',
        name: '',
      },
      refreshTokenTimer: null,
    }
  },
  computed: {
    globalConfig() {
      return Wiz.globalSettings.globalConfig
    },
  },
  methods: {
    async getUserDetail() {
      const [err, res] = await this.eafProfileApi.getCurrentUserEafProfile()
      if (!err && res.userInfo) {
        const userInfo = {}
        forIn(res.userInfo, (value, key) => {
          const undderscoreKey = key.replace(/([A-Z])/g, '_$1').toLowerCase()
          userInfo[undderscoreKey] = value
        })
        console.log(Wiz, 'wiz---')
        await Wiz.AuthHooks.SetUserInfo({
          access_token: this.token,
          profile: { tenantName: this.tenant.name, tenantid: this.tenant.id, ...userInfo },
        })
      }
    },
  },
  async created() {
    console.log('come in fullscreen')
    clearInterval(this.refreshTokenTimer)
    // 初始化主题
    // const currentTheme = Wiz.globalSettings.layout?.config?.defaultTheme || 'light'
    // this.$store.dispatch('System/currentTheme', currentTheme)
    // document.getElementsByTagName('body')[0].className = `h-full ${currentTheme} saas`
    /**
     * 1. 获取url token
     * 2. 获取配置的租户信息
     * 2. 根据token获取用户信息，setUserInfo,给接口注入token
     * 3. 进入目标页面
     */
    if (this.$route.query.token) {
      // 携带token进入
      const query = cloneDeep(this.$route.query)
      this.token = query.token
      delete query.token
      this.$router.replace({
        path: this.$route.path,
        query,
        params: this.$route.params,
      })
    } else if (window.__POWERED_BY_QIANKUN__) {
      this.token = localStorage.getItem('authorization')
      this.refreshTokenTimer = setInterval(() => {
        this.token = localStorage.getItem('authorization')
        axios.defaults.headers.common.Authorization = `Bearer ${this.token}`
      }, Wiz.globalSettings?.globalConfig?.refreshTokenTime || 30000)
    } else {
      this.token = Wiz.AuthHooks.GetToken()
    }
    this.tenant.id = JSON.parse(window.localStorage.getItem('CurrentUser'))?.TenantId || ''
    axios.defaults.headers.common.Authorization = `Bearer ${this.token}`
    axios.defaults.headers.common['X-Wiz-Tenant-Id'] = this.tenant.id
    console.warn(this.token)
    if (!this.token) {
      await Wiz.AuthHooks.SetUserInfo(null)
      this.layoutLoaded = true
      return
    }
    await Wiz.AuthHooks.SetUserInfo({
      access_token: this.token,
    })
    this.eafTenantApi = new EafTenantApi()
    this.eafProfileApi = new EafProfileApi()
    this.tenant.name = this.globalConfig.tenantName
    await this.getUserDetail()
    this.layoutLoaded = true
  },
  mounted() {
    // 获取主题配置
    const themeConfig = Wiz.globalSettings.layout.config
    let currentTheme = 'darkBlue'
    if (themeConfig) {
      currentTheme = !_.isNil(themeConfig.defaultTheme) ? themeConfig.defaultTheme : ''
    }
    this.$store.dispatch('System/currentTheme', currentTheme)
    document.getElementsByTagName('body')[0].classList.add(currentTheme)
    if (!window.__POWERED_BY_QIANKUN__) {
      // 非低代码
      return
    }
    const appMainMicroi = document.getElementsByClassName('app-main-microi')
    const microiService = document.getElementById('MicroiService')
    // 添加icon start
    const body = document.getElementsByTagName('body')[0]
    const head = document.getElementsByTagName('head')[0]
    const link = document.createElement('link')
    link.rel = 'stylesheet'
    link.href = '/lib/iconfont/iconfont.css'
    head.firstChild.appendChild(link)
    console.log(head, 'head')
    const playerPlugins = ['Player.js', 'PlayerUtils.js', 'qwebchannel.js']
    _.forEach(playerPlugins, (name) => {
      const script = document.createElement('script')
      script.src = `/lib/player/${name}`
      body.firstChild.appendChild(script)
    })
    const videoPlugins = ['h5player.min.js']
    _.forEach(videoPlugins, (name) => {
      const script = document.createElement('script')
      script.src = `/lib/video/HKh5Player/${name}`
      body.firstChild.appendChild(script)
    })
    // 添加icon end
    if (
      this.$route.query.ShowClassicTop === 'false' &&
      this.$route.query.ShowClassicLeft === 'false'
    ) {
      microiService.classList.add('full-screen')
      appMainMicroi[0].classList.add('full-screen')
      return
    }
    microiService.classList.remove('full-screen')
    appMainMicroi[0].classList.remove('full-screen')
  },
  destoryed() {
    clearInterval(this.refreshTokenTimer)
  },
}
</script>
